const RM32D_INTRO_STORAGE_PREFIX = 'rm32d-intro-seen'

export function getRm32dIntroStorageKey(userId?: number | null): string {
  if (userId) {
    return `${RM32D_INTRO_STORAGE_PREFIX}-${userId}`
  }
  return `${RM32D_INTRO_STORAGE_PREFIX}-guest`
}

export function hasSeenRm32dIntro(userId?: number | null): boolean {
  if (typeof window === 'undefined') return true
  return localStorage.getItem(getRm32dIntroStorageKey(userId)) === '1'
}

export function markRm32dIntroSeen(userId?: number | null): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(getRm32dIntroStorageKey(userId), '1')
}
